import { createI18n } from 'vue-i18n'
import fr from './locales/fr'
import tr from './locales/tr'
import en from './locales/en'
import de from './locales/de'

/**
 * Read the user's previously-saved language choice synchronously at module
 * init so the initial render (e.g. EmberLoaderIfo's "Yükleniyor" text) uses
 * the correct locale instead of flashing the default 'fr' and then switching
 * once backend config_language resolves.
 *
 * Key ('user_lang_choice') matches LANG_STORAGE_KEY in @/event/locale.ts.
 * Kept as a literal here to avoid a circular import (locale.ts imports i18n).
 */
function getInitialLocale(): 'fr' | 'tr' | 'en' | 'de' {
    const supported = ['fr', 'tr', 'en', 'de'] as const
    try {
        const saved = typeof localStorage !== 'undefined'
            ? localStorage.getItem('user_lang_choice')
            : null
        if (saved && (supported as readonly string[]).includes(saved)) {
            return saved as typeof supported[number]
        }
    } catch {
        /* localStorage blocked (private mode / SSR) — fall through */
    }
    return 'fr'
}

const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(), // rehydrated from localStorage; backend config may still override
    fallbackLocale: 'fr',
    messages: { fr, tr, en, de }
})

export default i18n

/**
 * Language code → language_id mapping (matches 8i9_language table)
 */
export const LANGUAGE_MAP: Record<string, number> = {
    tr: 1,
    en: 2,
    fr: 3,
    de: 4
}

/**
 * Currency code → symbol mapping (matches 8i9_currency table)
 */
export const CURRENCY_SYMBOLS: Record<string, { symbol: string; position: 'left' | 'right' }> = {
    TRY: { symbol: '₺', position: 'right' },
    USD: { symbol: '$', position: 'left' },
    EUR: { symbol: '€', position: 'right' },
    GBP: { symbol: '£', position: 'left' }
}
